import type { ServerResponseV1 } from "@/http"
import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"

interface UseDeleteCommentArgs {
  eventVaultId: number
  commentId: number
}

export async function deleteComment(eventVaultId: number, commentId: number) {
  await v1.delete<ServerResponseV1<void>>(`${eventVaultId}/comments/${commentId}`)
}

export function useDeleteComment() {
  return useMutation({
    mutationFn: ({ eventVaultId, commentId }: UseDeleteCommentArgs) => deleteComment(eventVaultId, commentId),
  })
}
